import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

const SliderImageContent = ({ data }) => {
  const { slider, type, sectionTitle } = data;
  return (
    <div className="flex flex-wrap">
      {sectionTitle && (
        <h2
          className={`mb-6 w-full basis-full px-4 text-center font-openSans text-4xl text-secondary`}
        >
          {sectionTitle}
        </h2>
      )}
      <div className="w-full basis-full px-4">
        <Swiper
          spaceBetween={0}
          slidesPerView={1}
          autoplay={{ delay: 7500, disableOnInteraction: false }}
          modules={[Navigation, Autoplay]}
          navigation={true}
        >
          {slider?.map((slide, index) => {
            const imageData = getImage(
              slide?.image?.localFile?.childImageSharp?.gatsbyImageData
            );
            if (type === "type1") {
              return (
                <SwiperSlide key={index}>
                  <div className="flex flex-wrap">
                    <div
                      className={`w-full basis-full lg:w-1/2 lg:basis-1/2 ${
                        slide.imagePosition === "right"
                          ? "order-2"
                          : "order-none"
                      }`}
                    >
                      <GatsbyImage image={imageData} alt="" />
                    </div>
                    <div
                      className={`w-full basis-full bg-lightgrey p-8 lg:w-1/2 lg:basis-1/2 ${
                        slide.imagePosition === "right"
                          ? "order-1"
                          : "order-none"
                      }`}
                    >
                      {slide.title && (
                        <h4 className="mb-4 text-left font-openSans text-lg text-secondary xl:text-4xl">
                          {slide.title}
                        </h4>
                      )}
                      <div
                        className="red-bulleted text-left font-openSans text-base text-black xl:text-xl"
                        dangerouslySetInnerHTML={{ __html: slide.content }}
                      ></div>
                      {slide.button && (
                        <a
                          href={slide.button.url}
                          target={slide.button.target}
                          className="mt-4 inline-block rounded-xl bg-white px-10 py-2 font-openSans uppercase text-black"
                        >
                          {slide.button.title}
                        </a>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              );
            } else if (type === "type2") {
              return (
                <SwiperSlide key={index}>
                  <div className="relative w-full basis-full">
                    <GatsbyImage image={imageData} alt="" />
                    <div
                      className={`relative top-0 left-0 z-10 flex h-full w-full flex-wrap items-end justify-center p-8 xl:absolute`}
                    >
                      <div className={`w-full basis-full`}>
                        {slide.title && (
                          <h4
                            className={`mb-4 text-center font-openSans text-lg text-black xl:text-5xl xl:text-white`}
                          >
                            {slide.title}
                          </h4>
                        )}
                        <div
                          className="page-content font-futura text-left text-base text-black xl:text-xl xl:text-white"
                          dangerouslySetInnerHTML={{ __html: slide.content }}
                        ></div>
                        {slide.button && (
                          <a
                            href={slide.button.url}
                            target={slide.button.target}
                            className="mt-4 inline-block rounded-xl bg-white px-10 py-2 font-openSans uppercase text-black"
                          >
                            {slide.button.title}
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            } else {
              return (
                <SwiperSlide key={index}>
                  <div className="relative w-full basis-full">
                    <GatsbyImage image={imageData} alt="" />
                    <div
                      className={`relative top-0 left-0 z-10 flex h-full w-full flex-wrap items-center justify-end xl:absolute xl:p-8`}
                    >
                      <div
                        className={`w-full basis-full bg-primary p-2 lg:w-1/3 lg:basis-1/3 xl:p-8`}
                      >
                        {slide.title && (
                          <h4
                            className={`mb-4 text-left font-openSans text-lg text-white xl:text-5xl`}
                          >
                            {slide.title}
                          </h4>
                        )}
                        <div
                          className="page-content font-futura text-left text-base text-white xl:text-xl"
                          dangerouslySetInnerHTML={{ __html: slide.content }}
                        ></div>
                        {slide.button && (
                          <a
                            href={slide.button.url}
                            target={slide.button.target}
                            className="mt-4 inline-block rounded-xl bg-white px-10 py-2 font-openSans uppercase text-black"
                          >
                            {slide.button.title}
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            }
          })}
        </Swiper>
      </div>
    </div>
  );
};

export default SliderImageContent;
